<script setup lang="tsx">
  import MonetaryDonationDrawer from './RoutedDrawerCollection/MonetaryDonationDrawer.vue';
  import InKindDonationDrawer from './RoutedDrawerCollection/InKindDonationDrawer.vue';
  import DonorsDrawer from './RoutedDrawerCollection/DonorsDrawer.vue';
  import AllGrantsDrawer from './RoutedDrawerCollection/AllGrantsDrawer.vue';
  import AllPledgesDrawer from './RoutedDrawerCollection/AllPledgesDrawer.vue';
  import AllBudgetDrawer from './RoutedDrawerCollection/AllBudgetDrawer.vue';
  import ContactTypeDrawer from './RoutedDrawerCollection/ContactTypeDrawer.vue';
  import AccountingPeriodDrawer from './RoutedDrawerCollection/AccountingPeriodDrawer.vue';
  import PurposeDrawer from './RoutedDrawerCollection/PurposeDrawer.vue';
  import StockItemDrawer from './RoutedDrawerCollection/StockItemDrawer.vue';
  import LedgerDrawer from './RoutedDrawerCollection/LedgerDrawer.vue';
  import CostCentreDrawer from './RoutedDrawerCollection/CostCentreDrawer.vue';
  import UserInformationDrawer from './RoutedDrawerCollection/UserInformationDrawer.vue';
  import AllAdvancesDrawer from './RoutedDrawerCollection/AllAdvancesDrawer.vue';
  import VendorDrawer from './RoutedDrawerCollection/VendorDrawer.vue';
  import ExpensePaymentManagementDrawer from './RoutedDrawerCollection/ExpensePaymentManagementDrawer.vue';
  import AllExpensesDrawer from './RoutedDrawerCollection/AllExpensesDrawer.vue';
  import AllRecurringExpensesDrawer from './RoutedDrawerCollection/AllRecurringExpensesDrawer.vue';
  import PayeeTypeDrawer from './RoutedDrawerCollection/PayeeTypeDrawer.vue';
  import AdvancePaymentManagementDrawer from './RoutedDrawerCollection/AdvancePaymentManagementDrawer.vue';

  const identifier = ref<string | null>(null);
  const drawerFrom = ref<string | null>(null);

  const route = useRoute();
  const router = useRouter();

  const onClose = () => {
    const { drawerFrom, identifier, action, ...rest } = route.query;
    router.replace({ query: { ...rest } });
  };

  const openModal = (modalType: string, identifier: string) => {
    const { drawerFrom, ...restQuery } = route.query;
    router.replace({
      query: {
        ...restQuery,
        modalFor: modalType,
        identifier: identifier
      }
    });
  };

  watch(
    () => route.query,
    newQuery => {
      if (newQuery.drawerFrom) {
        drawerFrom.value = newQuery.drawerFrom as string;
        identifier.value = (newQuery.identifier as string) || null;
      } else {
        identifier.value = null;
        drawerFrom.value = null;
      }
    },
    { immediate: true, deep: true }
  );
</script>

<template>
  <MonetaryDonationDrawer
    v-if="drawerFrom === 'monetaryDonations'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <InKindDonationDrawer
    v-if="drawerFrom === 'inKindDonations'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <DonorsDrawer
    v-if="drawerFrom === 'donors'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <VendorDrawer
    v-if="drawerFrom === 'payees'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllGrantsDrawer
    v-if="drawerFrom === 'allGrants'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllPledgesDrawer
    v-if="drawerFrom === 'allPledges'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllBudgetDrawer
    v-if="drawerFrom === 'allBudgets'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllBudgetDrawer
    v-if="drawerFrom === 'pending_approval_on_me'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllBudgetDrawer
    v-if="drawerFrom === 'approved_and_active'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllAdvancesDrawer
    v-if="drawerFrom === 'allAdvances'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <ExpensePaymentManagementDrawer
    v-if="drawerFrom === 'expensesPaymentManagement'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AdvancePaymentManagementDrawer
    v-if="drawerFrom === 'advancePaymentDrawer'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllExpensesDrawer
    v-if="drawerFrom === 'allExpenses'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <AllRecurringExpensesDrawer
    v-if="drawerFrom === 'allRecurringExpenses'"
    :open-modal="openModal"
    :identifier="identifier || ''"
    @close="onClose"
  />
  <ContactTypeDrawer v-if="drawerFrom === 'donorTypes'" :identifier="identifier || ''" @close="onClose" />
  <PayeeTypeDrawer v-if="drawerFrom === 'payeeTypes'" :identifier="identifier || ''" @close="onClose" />
  <AccountingPeriodDrawer v-if="drawerFrom === 'accountingPeriods'" :identifier="identifier || ''" @close="onClose" />
  <PurposeDrawer v-if="drawerFrom === 'purposes'" :identifier="identifier || ''" @close="onClose" />
  <StockItemDrawer v-if="drawerFrom === 'stockItems'" :identifier="identifier || ''" @close="onClose" />
  <LedgerDrawer v-if="drawerFrom === 'ledgers'" :identifier="identifier || ''" @close="onClose" />
  <CostCentreDrawer v-if="drawerFrom === 'costCentres'" :identifier="identifier || ''" @close="onClose" />
  <UserInformationDrawer v-if="drawerFrom === 'userInformation'" :identifier="identifier || ''" @close="onClose" />
</template>
